import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IStateDashboardSearchFields, IStateDashboardSearchRequest } from '@core/interfaces/istate-dashboard';
import { StateService } from '@core/services/state.service';
import { take } from 'rxjs';

@Component({
    selector: 'drdp-search-programs',
    templateUrl: './search-programs.component.html',
    styleUrls: ['./search-programs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchProgramsComponent {
  private stateService = inject(StateService);
  
  displayDropdowns: IStateDashboardSearchFields = {
    ageGroup: true,
    enrollmentProgram: true,
    homeLanguage: false,
    globalRatingPeriods: false,
    disability: false
  };
  requiredFields: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    globalRatingPeriods: false,
    disability: false
  };

  handleSearch(searchValue: IStateDashboardSearchRequest): void {
    this.stateService.searchProgramsByAgeGroup(searchValue).pipe(take(1)).subscribe(res => {
      const fileName = 'Programs.xlsx';
      const blob = new Blob([res.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
    });
  }
}
